<template>
<div class="container" :class="{loadingItem: isProductLoading}">
  <div class="row text-center" v-if="isProductLoading">
    <grid-loader :loading="isProductLoading" :color="loaderColor" :size="loaderSize"></grid-loader>
  </div>
  <div v-else class="row action-panel">
    <div class="col-12">
      <div>
        類別 : 
        <select v-model="selectedCategory" class="custom-select col-md-2" >
          <option v-for="opt in category" :value="opt" :key="opt">{{opt}}</option>
          <!-- <option value="all">all</option>
          <option value="pc">pc</option>
          <option value="npc">npc</option> -->
        </select>
        * 如果有想要購買的，不知道如何購買，歡迎寄信到 ekids12345@gmail.com 或是聯繫 FB !
      </div>
      <div class="btn-group btn-group-sm pull-right">
				<button id="list" class="btn btn-outline-dark" @click.prevent="changeDisplay(true)">
          <i class="fa fa-list" aria-hidden="true"></i> List
				</button>
				<button id="grid" class="btn btn-outline-dark" @click.prevent="changeDisplay(false)">
          <i class="fa fa-th" aria-hidden="true"></i> Grid
				</button>
      </div>
    </div>
  </div>

  <div class="row" v-if="!isProductLoading">
    <app-product-item v-for="prod in computed_items" :item="prod" :key="prod.id" :displayList="displayList"></app-product-item>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductItem from './product/ProductItem.vue';
import GridLoader from 'vue-spinner/src/GridLoader.vue';

export default {
  data() {
    return {
      loaderColor: "#5cb85c",
      loaderSize: "50px",
      displayList: false,
      selectedCategory: '全部',
      category:['全部','LoveLive','Bang Dream','生寫真', '胸章', 'UNIT LIVE ADVENTURE 2020', '王劍', 'PVC', 'LoveLive FES', '前島亞美']
    }
  },
  computed: {
    ...mapGetters(['products', 'isProductLoading']),
    computed_items: function () {
      let filterType= this.selectedCategory
      return this.products.filter(function(item){
        let filtered = false
        if(filterType == '全部') return true
        if(filterType && filterType.length > 0){
          for(let eachCategory of item.category){
            if(eachCategory.toUpperCase() == filterType.toUpperCase()){
              return true
            }
          }
        }
        return filtered
      })
    } // end of computed_item
    
  },
  components: {
    appProductItem: ProductItem,
    GridLoader
  },
  methods: {
    changeDisplay(isList) {
      this.displayList = isList;
    }
  }
}
</script>

<style>
.loadingItem {
  align-items: center;
  justify-content: center;
  display: flex;
}

.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>
